export default "__VITE_ASSET__Dnx8uPq3__"